import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import BannerInner from '../components/BannerInner';
import ProjectSlider from '../components/ProjectSlider';
import FloorPlan from '../components/FloorPlan';
import RateListPlots from '../components/RateListPlots';
import Attachments from '../components/Attachments';
import LocationMap from '../components/LocationMap';
import MoreAboutProject from '../components/MoreAboutProject';
import Archives from '../components/Archives';
import EnquiryForm from '../components/EnquiryForm';
import {BsPhone, BsTelephone, BsEnvelope} from "react-icons/bs";
import CommonHelmet from '../components/CommonHelmet';
import axiosInstance from '../axiosInstance';
import { getFullImageUrl } from '../utils/apiBase';

const Projects = () => {
    const { slug } = useParams();
    const title='Best Residential Plots in Faizabad Road, Lucknow | Urbanaid Uniworld';
    const description='Urbanaid Uniworld is one of the best Real Estate project of Urbanaid Infratech which known as a Best Real Estate Company in Lucknow. Call - 8009340786 for more infomation';
    const canonical='/urbanaiduniworld';

    const [contactData, setContactData] = useState(null);
    const [projectData, setProjectData] = useState(null);
    //const [isLoading, setLoading] = useState(true);
    
    const fetchAllData = async () => {
        try {
            const token = localStorage.getItem("token");

            const [contactRes, projectRes] = await Promise.all([
                axiosInstance.get('/api/fetchcontactnew', {
                    headers: {
                        Authorization: `${token}`,
                    }
                }),
                axiosInstance.get(`/api/getprojectbyslug/${slug}`)
            ]);

            if (contactRes.data?.length > 0) {
                setContactData(contactRes.data[0]);
            }
            setProjectData(projectRes.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    
    useEffect(() => {
        if (slug) {
            fetchAllData();
        }
    }, [slug]);

    const imagesData = projectData?.images?.map((image, index) =>(
        {
            id:index+1,
            img:image.webppath,
            alttext:image.alttext,
        }
    )) || [];
    
    const floorPlanData = projectData?.floors?.map((floor, index) =>(
            {
            id: floor.id,
            floorsize: floor.floorsize,
            floortitle1: floor.floortitle1,
            floorimg1_path: floor.floorimage1_path,
            floortitle2: floor.floortitle2,
            floorimg2_path: floor.floorimage2_path,
        }
        )) || [];
    // Plot Rate List
    const rowDataRatePlot = projectData?.ratelistplots?.map((plots, index) =>(
        {
            id: index + 1,
            block: plots.block,
            plot: plots.plot,
            minarea: plots.minarea,
            maxarea: plots.maxarea,
            rate: plots.rate,
        }
    )) || [];
    
    const columndataRatePlot = [
        { id: 1, accessor: 'sno', title: 'S. No.', width:70, },
        { id: 2, accessor: 'block', title: 'Block', width:130, titleClassName: '!text-center', },
        { id: 2, accessor: 'plot', title: 'Plot', width:130, titleClassName: '!text-center', },
        { id: 3, accessor: 'minarea', title: 'Minimum Area (sqft)', width:130, titleClassName: '!text-center', },
        { id: 4, accessor: 'maxarea', title: 'Maximum Area (sqft)', width:130, titleClassName: '!text-center', },
        { id: 5, accessor: 'rate', title: 'Rate(Rs.)/Sqft', titleClassName: '!text-center', },
    ];
    
    const noteDataPlot = projectData?.project?.noteplots;
    const amenitiesDataPlot = projectData?.project?.plotamenities || [];

    // Row House Rate List
    const rowDataRateHouse = projectData?.ratelisthouses?.map((houses, index) =>(               
        {
            id: index + 1,
            block: houses.block,
            size: houses.plotsize,
            plotarea: houses.plotarea,
            coveredarea: houses.coveredarea,
            fasing: houses.fasing,
            rooms: houses.rooms,
            washroom: houses.washroom,
            mumty: houses.mumty,
            semirate: houses.semirate,
            rate: `${houses.rate}${houses.gst > 0 ?` <br><span class="text-red-500">(${houses.gst}% GST ${houses.gsttype})</span>` : ""}`,
        }
    )) || [];
    
    const columndataRateHouse = [
        { id: 1, accessor: 'sno', title: 'S. No.', width:70, },
        { id: 2, accessor: 'block', title: 'Block', width:90, titleClassName: '!text-center', },
        { id: 2, accessor: 'size', title: 'Size', width:90, titleClassName: '!text-center', },
        { id: 3, accessor: 'plotarea', title: 'Plot Area (Sqft)', width:100, titleClassName: '!text-center', },
        { id: 4, accessor: 'coveredarea', title: 'Total Covered Area (Sqft)', width:100, titleClassName: '!text-center', },
        { id: 5, accessor: 'fasing', title: 'Fasing', titleClassName: '!text-center', width:90, },
        { id: 6, accessor: 'rooms', title: 'Rooms', titleClassName: '!text-center', width:90, },
        { id: 7, accessor: 'washroom', title: 'Washroom', titleClassName: '!text-center', width:90, },
        { id: 8, accessor: 'mumty', title: 'Mumty', titleClassName: '!text-center', width:90, },
        { id: 9, accessor: 'semirate', title: 'Semi Furnished Rate', titleClassName: '!text-center', width:90, },
        { id: 10, accessor: 'rate', title: 'FULLY FRUNISHED RATE with Amenities', titleClassName: '!text-center', },
    ];

    const noteDataHouse = projectData?.project?.notehouses;
    const amenitiesDataSite = [
        {
            id: 1,
            text: "70', 50', 30' Roads",
        },
        {
            id: 2,
            text: "Sewage Treatment Plant",
        },
        {
            id: 3,
            text: "Rain Water Harvesting",
        },
        {
            id: 4,
            text: "24*7 CCTV Camera",
        },
        {
            id: 5,
            text: "100000 lt Capacity Water Tank",
        },
        {
            id: 6,
            text: "Security Guard",
        },
    ];
    const amenitiesDataHouse = projectData?.project?.houseamenities || [];
    console.log(amenitiesDataHouse);

    const interiorData = projectData?.project?.interiordetail;

    const ratePlan = [
        {
            id: 1,
            title: 'Rate List (Plots)',
            rowDataRate: rowDataRatePlot,
            columnDataRate: columndataRatePlot,
            noteData: noteDataPlot,
            amenitiesData: [
                {
                    id: 1,
                    title: 'Amenities',
                    amenitiesData: amenitiesDataPlot,
                }
            ],
            interiorData: '',
        },
        {
            id: 2,
            title: 'Rate List (Houses)',
            rowDataRate: rowDataRateHouse,
            columnDataRate: columndataRateHouse,
            noteData: noteDataHouse,
            amenitiesData: [
                {
                    id: 1,
                    title: 'Amenities',
                    amenitiesData: amenitiesDataHouse,
                }
            ],
            interiorData: interiorData,
        },
    ];

    const attachments = [
        {
            id: 1,
            title: 'Project Plan',
            url: projectData?.project?.projectplanpath ? getFullImageUrl(projectData.project.projectplanpath)
                : null,
        },
        {
            id: 2,
            title: 'Project Brochure',
            url: projectData?.project?.projectbrochurepath ? getFullImageUrl(projectData.project.projectbrochurepath)
                : null,
        },
    ];

    const locationMap = projectData?.project?.locationmap;

    const addressData = {
        address: projectData?.project?.siteaddress,
        city: 'Lucknow',
        state: 'Uttar Pradesh',
        country: 'Bharat (India)',
    };
    //const someElement = useRef();
    const archivesData = [
        {
            id: 1,
            archives: "Gallery",
        },
        {
            id: 2,
            archives: "Events",
        },
        {
            id: 3,
            archives: "Videos",
        },
    ];

    return (
        
        <>        
            <CommonHelmet title={title} canonical={canonical} description={description} />
            <BannerInner title={'Projects'} />
            <div className='flex text-sm leading-6'>
                <div className='container mx-auto'>
                <section className='flex flex-col py-6'>
                        <div className='w-full flex pb-4'>
                            <ProjectSlider projectimages={imagesData} />
                        </div>
                        <div className='projectdetail flex flex-col md:flex-row gap-10 py-2 relative'>
                            <div className='w-full flex flex-col gap-6'>
                                <div className='grid grid-cols-1 md:grid-cols-[3fr_1fr] gap-6'>
                                    <div className='flex flex-col py-4 px-4 md:px-7 bg-white text-gray-900 box-shadow rounded-xl'>
                                        <h2 className='text-xl leading-8 font-bold uppercase font-montserrat pb-2 mb-4 text-gray-900 text-center border-b border-gray-200 border-solid'>Project Detail</h2> 
                                        <div className='mb-5 prose prose-sm max-w-none' dangerouslySetInnerHTML={{ __html: projectData?.project?.projectdetail }}></div>
                                    </div>
                                    <Attachments attachments={attachments} />
                                </div>

                                {/* <ProjectPlan projectPlan={projectplanimg} /> */}
                                
                                {floorPlanData?.length > 0 && (<FloorPlan title={'Floor Plan'} floorPlanData={floorPlanData} />) }
                                {ratePlan.some(r => r.rowDataRate && r.rowDataRate.length > 0) && (
                                    ratePlan
                                        .filter(r => r.rowDataRate && r.rowDataRate.length > 0).map((rateContent)=> (
                                        <RateListPlots key={rateContent.id} title={rateContent.title} rowDataRate={rateContent.rowDataRate} columnDataRate={rateContent.columnDataRate} noteData={rateContent.noteData} amenitiesData={rateContent.amenitiesData} interiorData={rateContent.interiorData} />
                                    )
                                ))}
                                
                                <LocationMap locationMap={locationMap} addressData={addressData} />
                                <MoreAboutProject />
                            </div>
                        </div>
                    </section>                     
                </div>
            </div>
        </>
    );
}

export default Projects;